import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Reservation } from '../classes/reservation';
import { ReservationService } from '../services/reservation.service';
import * as moment from 'moment';

@Component({
  selector: 'app-reservation',
  templateUrl: './reservation.component.html',
  styleUrls: ['./reservation.component.scss']
})
export class ReservationComponent implements OnInit {

  noDateSelected = true;

  availableTimes: Array<string> = new Array<string>(); //= new Array<string>("17:00", "17:30", "18:00", "18:30", "19:00", "19:30", "20:00", "20:30")

  reservationFormGroup: FormGroup;

  successfullyReserved: boolean = false;

  failedToReserve: boolean = false

  minDate: Date = new Date();

  loading: boolean = false;

  loadingTimes: boolean = false;

  constructor(private formBuilder: FormBuilder, private reservationService: ReservationService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {

    this.reservationFormGroup = this.formBuilder.group({
      date: ['', Validators.required],
      time: ['', Validators.required],
      name: ['', Validators.required],
      email: ['', Validators.required],
      numberOfPeople: ['', Validators.required],
      mobile: ['', Validators.required],
      comments: ['']
    })

    this.reservationFormGroup.get("date").valueChanges.subscribe(x => {
      this.availableTimes = new Array<string>();
      this.loadingTimes = true;
      if (!!this.reservationFormGroup.get("date").value)
      {
        this.noDateSelected = false;
        this.reservationFormGroup.get("time").reset();
        var date = new Date(this.reservationFormGroup.get("date").value);  
        const yy = new Date(date).getFullYear();
        const mm = new Date(date).getMonth() + 1;
        const dd = new Date(date).getDate();
    
        var interMedDt = `${dd}-${mm}-${yy}`
        this.reservationService.GetReservationTimes(interMedDt).subscribe(y => {
          y.forEach(x => {
            var toDate = new Date(x);
            this.availableTimes.push(`${toDate.getHours()}:${(toDate.getMinutes()<10?'0':'') + toDate.getMinutes()}`)
          });
          this.loadingTimes = false;
        });
      }
    });
  }

  submit() {

    this.loading = true;

    if (this.reservationFormGroup.invalid)
    {
      this.reservationFormGroup.markAllAsTouched();
      this.loading = false;
      return;
    }

    var date = new Date(this.reservationFormGroup.get("date").value);
    var time = this.reservationFormGroup.get("time").value;

    const yy = new Date(date).getFullYear();
    const mm = new Date(date).getMonth();
    const dd = new Date(date).getDate();

    // var interMedDt = new Date(mm + '-' + dd + '-' + yy);
    // interMedDt.setHours((time.split(' ')[0]).split(':')[0]);
    // interMedDt.setMinutes((time.split(' ')[0]).split(':')[1]);

    var temp = moment.utc([yy, mm, dd, +(time.split(' ')[0]).split(':')[0], +(time.split(' ')[0]).split(':')[1], 0, 0]).format();

    var reservation: Reservation = {
      name: this.reservationFormGroup.get("name").value,
      email: this.reservationFormGroup.get("email").value,
      phoneNumber: this.reservationFormGroup.get("mobile").value.toString(),
      numberOfPeople: +this.reservationFormGroup.get("numberOfPeople").value,
      reservedDateTime: temp,
      comments: this.reservationFormGroup.get("comments").value
    }

    this.reservationService.CreateReservation(reservation).subscribe(x => {
      this.successfullyReserved = true;
      this.failedToReserve = false;
      this.loading = false;
    }, (error) => {
      this.failedToReserve = true;
      this.loading = false;
    })
  }

  myFilter = (d: Date): boolean => {
    const day = d.getDay();
    const month = d.getMonth();
    const year = d.getFullYear();

    return day !== 1;
  }

  checkDateIsSelected()
  {
    if (!this.reservationFormGroup.get('date').value)
    {
      this.reservationFormGroup.get('date').setErrors({selectDate:true});
      this.reservationFormGroup.get('time').setErrors({selectDate:true});
      this.cdr.detectChanges();
    }
  }

}
